import {
  ContentLibraryFileEntry,
  ContentLibraryState,
  ContentLibraryType,
} from 'features/content-library/types';

export const openedFileInitialState = {
  data: null,
  currentPage: 0,
};

// Utility function to find a file across all libraries and optionally update it
export const findAndUpdateFileInLibraries = <T extends ContentLibraryFileEntry>(
  state: ContentLibraryState,
  fileId: string,
  updateFn?: (file: T) => void
): T | undefined => {
  for (const libraryType of ['personal', 'room'] as ContentLibraryType[]) {
    const library = state.libraries[libraryType];
    const file = library.files[fileId] as T;

    if (file) {
      if (updateFn) {
        updateFn(file);
      }
      return file;
    }
  }

  return undefined;
};

export const closeActiveFile = (state: ContentLibraryState, fileId: string) => {
  if (state.activeFiles[fileId]) {
    delete state.activeFiles[fileId];
  }

  if (state.openedFile.data?.id === fileId) {
    state.openedFile = {
      ...openedFileInitialState,
    };
  }
};

export const closeActiveWhiteboard = (state: ContentLibraryState, whiteboardId: string) => {
  if (state.activeWhiteboards[whiteboardId]) {
    delete state.activeWhiteboards[whiteboardId];
  }

  if (state.openedFile.data?.id === whiteboardId) {
    state.openedFile = {
      ...openedFileInitialState,
    };
  }
};
